import React from 'react'
import { useDispatch } from 'react-redux'
import { useEffectOnce, Spinner } from '@chilecompra/react-kit'
import { onLogoutThunk } from './Logout.actions'
import { Root } from './Logout.styles'

/**
 * The Logout's container.
 */
const Logout = () => {
  const dispatch = useDispatch()

  useEffectOnce(() => {
    dispatch(onLogoutThunk())
  })

  return (
    <Root>
      <Spinner />
    </Root>
  )
}

export default Logout
